"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerClient = void 0;
var tslib_1 = require("tslib");
var commerce_core_1 = require("@broadleaf/commerce-core");
/**
 * Client used for interacting with the Browse APIs.
 */
var CustomerClient = /** @class */ (function (_super) {
    tslib_1.__extends(CustomerClient, _super);
    function CustomerClient(options) {
        return _super.call(this, tslib_1.__assign(tslib_1.__assign({}, options), { basePath: options.basePath || '/api/customer' })) || this;
    }
    /**
     * Retrieves a single Customer by Id
     *
     * @param customerId the customer id to fetch
     * @param options the options to the HTTP call
     * @return a single Customer
     */
    CustomerClient.prototype.getCustomer = function (customerId, options) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var config, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        config = {
                            method: 'get',
                            url: "/customers/" + customerId
                        };
                        return [4 /*yield*/, this.call(config, options)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response === null || response === void 0 ? void 0 : response.data];
                }
            });
        });
    };
    /**
     * Update a customer with new data
     *
     * @param customerId the customer id to update
     * @param customer the new customer data
     * @param options the options to the HTTP call
     * @return a updated Customer
     */
    CustomerClient.prototype.updateCustomer = function (customerId, customer, options) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var config, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        config = {
                            method: 'put',
                            url: "/customers/" + customerId,
                            data: customer
                        };
                        return [4 /*yield*/, this.call(config, options)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response === null || response === void 0 ? void 0 : response.data];
                }
            });
        });
    };
    /**
     * Retrieves a page of customer address
     *
     * @param customerId the customer id to retrieve addresses for
     * @param options the options to the HTTP call
     * @return a page of customer address
     */
    CustomerClient.prototype.listCustomerAddresses = function (customerId, options) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var config, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        config = {
                            method: 'get',
                            url: "/customers/" + customerId + "/addresses",
                            params: {}
                        };
                        this.attachPageableParamsIfPresent(config, options);
                        return [4 /*yield*/, this.call(config, options)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response === null || response === void 0 ? void 0 : response.data];
                }
            });
        });
    };
    /**
     * Retrieves a customer address
     *
     * @param customerId the customer id which owns the address
     * @param customerAddressId the customer address id to retrieve
     * @param options the options to the HTTP call
     * @return a customer address
     */
    CustomerClient.prototype.getCustomerAddress = function (customerId, customerAddressId, options) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var config, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        config = {
                            method: 'get',
                            url: "/customers/" + customerId + "/addresses/" + customerAddressId
                        };
                        return [4 /*yield*/, this.call(config, options)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response === null || response === void 0 ? void 0 : response.data];
                }
            });
        });
    };
    /**
     * Adds a customer address to a customer
     *
     * @param customerId the customer id to add an address to
     * @param address the address to add
     * @param options the options to the HTTP call
     * @return the new customer address
     */
    CustomerClient.prototype.addCustomerAddress = function (customerId, address, options) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var config, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        config = {
                            method: 'post',
                            url: "/customers/" + customerId + "/addresses",
                            data: address
                        };
                        return [4 /*yield*/, this.call(config, options)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response === null || response === void 0 ? void 0 : response.data];
                }
            });
        });
    };
    /**
     * Updates a customer address
     *
     * @param customerId the customer id which owns the address
     * @param customerAddressId the customer address id to update
     * @param updatedAddress the updated address data
     * @param options the options to the HTTP call
     * @return the updated customer address
     */
    CustomerClient.prototype.updateCustomerAddress = function (customerId, customerAddressId, updatedAddress, options) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var config, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        config = {
                            method: 'put',
                            url: "/customers/" + customerId + "/addresses/" + customerAddressId,
                            data: updatedAddress
                        };
                        return [4 /*yield*/, this.call(config, options)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response === null || response === void 0 ? void 0 : response.data];
                }
            });
        });
    };
    /**
     * Deletes a customer address
     *
     * @param customerId the customer id which owns the address
     * @param customerAddressId the customer address id to delete
     * @param options the options to the HTTP call
     */
    CustomerClient.prototype.deleteCustomerAddress = function (customerId, customerAddressId, options) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var config, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        config = {
                            method: 'delete',
                            url: "/customers/" + customerId + "/addresses/" + customerAddressId
                        };
                        return [4 /*yield*/, this.call(config, options)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response === null || response === void 0 ? void 0 : response.data];
                }
            });
        });
    };
    /**
     * Retrieves a page of customer payment accounts
     *
     * @param customerId the customer id to retrieve payments for
     * @param options the options to the HTTP call
     * @return a page of payment accounts
     * @deprecated In favor of using {@link #listSavedPaymentMethods} and PaymentTransactionServices to manage saved payment methods
     */
    CustomerClient.prototype.listCustomerPaymentAccounts = function (customerId, options) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var config, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        config = {
                            method: 'get',
                            url: "/customers/" + customerId + "/payment-accounts",
                            params: {}
                        };
                        this.attachPageableParamsIfPresent(config, options);
                        return [4 /*yield*/, this.call(config, options)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response === null || response === void 0 ? void 0 : response.data];
                }
            });
        });
    };
    /**
     * Retrieves a customer payment account
     *
     * @param customerId the customer id which owns the payment account
     * @param paymentAccountId the payment account id to retrieve
     * @param options the options to the HTTP call
     * @return a customer payment account
     * @deprecated In favor of using {@link #getSavedPaymentMethod} and PaymentTransactionServices to manage saved payment methods
     */
    CustomerClient.prototype.getCustomerPaymentAccount = function (customerId, paymentAccountId, options) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var config, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        config = {
                            method: 'get',
                            url: "/customers/" + customerId + "/payment-accounts/" + paymentAccountId
                        };
                        return [4 /*yield*/, this.call(config, options)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response === null || response === void 0 ? void 0 : response.data];
                }
            });
        });
    };
    /**
     * Adds a payment account to a customer
     *
     * @param customerId the customer id to add a payment account to
     * @param paymentAccount the payment account to add
     * @param options the options to the HTTP call
     * @return the new payment account
     * @deprecated In favor of using {@link #addSavedPaymentMethod} and PaymentTransactionServices to manage saved payment methods
     */
    CustomerClient.prototype.addCustomerPaymentAccount = function (customerId, paymentAccount, options) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var config, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        config = {
                            method: 'post',
                            url: "/customers/" + customerId + "/payment-accounts",
                            data: paymentAccount
                        };
                        return [4 /*yield*/, this.call(config, options)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response === null || response === void 0 ? void 0 : response.data];
                }
            });
        });
    };
    /**
     * Updates a customer's payment account
     *
     * @param customerId the customer id which owns the payment account
     * @param paymentAccountId the payment account id to update
     * @param updatedPaymentAccount the updated payment account data
     * @param options the options to the HTTP call
     * @return the updated payment account
     * @deprecated In favor of using {@link #updateSavedPaymentMethod} and PaymentTransactionServices to manage saved payment methods
     */
    CustomerClient.prototype.updateCustomerPaymentAccount = function (customerId, paymentAccountId, updatedPaymentAccount, options) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var config, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        config = {
                            method: 'patch',
                            url: "/customers/" + customerId + "/payment-accounts/" + paymentAccountId,
                            data: updatedPaymentAccount
                        };
                        return [4 /*yield*/, this.call(config, options)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response === null || response === void 0 ? void 0 : response.data];
                }
            });
        });
    };
    /**
     * Deletes a customer's payment account
     *
     * @param customerId the customer id which owns the payment account
     * @param paymentAccountId the payment account id to delete
     * @param options the options to the HTTP call
     * @deprecated In favor of using {@link #deleteSavedPaymentMethod} and PaymentTransactionServices to manage saved payment methods
     */
    CustomerClient.prototype.deleteCustomerPaymentAccount = function (customerId, paymentAccountId, options) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var config, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        config = {
                            method: 'delete',
                            url: "/customers/" + customerId + "/payment-accounts/" + paymentAccountId
                        };
                        return [4 /*yield*/, this.call(config, options)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response === null || response === void 0 ? void 0 : response.data];
                }
            });
        });
    };
    /**
     * Retrieves the authenticated customer's order history
     *
     * @param options the options to the HTTP call
     * @return the customer's order history
     */
    CustomerClient.prototype.listCustomerOrderHistory = function (options) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var config, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        config = {
                            method: 'get',
                            url: "/order-history",
                            baseURL: this.baseHost + "/api/order-operations"
                        };
                        this.attachPageableParamsIfPresent(config, options);
                        return [4 /*yield*/, this.call(config, options)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response === null || response === void 0 ? void 0 : response.data];
                }
            });
        });
    };
    /**
     * Retrieves an order by id or order number for the authenticated
     *
     * @param orderRef the order's id or order number
     * @param options the options to the HTTP call
     * @return the requested order
     */
    CustomerClient.prototype.getCustomerOrder = function (orderRef, options) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var config, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        config = {
                            method: 'get',
                            url: "/order-history/" + orderRef,
                            baseURL: this.baseHost + "/api/order-operations"
                        };
                        return [4 /*yield*/, this.call(config, options)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response === null || response === void 0 ? void 0 : response.data];
                }
            });
        });
    };
    /**
     * Attaches pageable params (size, sort, etc.) to the request `config` if present on `options`.
     *
     * @param config The axios request config to modify
     * @param options Options specifying additional parameters to be used to modify the `config`
     */
    CustomerClient.prototype.attachPageableParamsIfPresent = function (config, options) {
        if (options) {
            var page = options.page, size = options.size, sort = options.sort;
            if (page || page === 0) {
                config.params.page = page;
            }
            if (size || size === 0) {
                config.params.size = size;
            }
            if (sort) {
                config.params.sort = sort;
            }
        }
    };
    return CustomerClient;
}(commerce_core_1.AbstractClient));
exports.CustomerClient = CustomerClient;
//# sourceMappingURL=customer-client.js.map